import axios from 'axios';

const apiHost = process.env.VUE_APP_API_HOST;

/**
 * Fire-and-forget: log a login-related error to the server so it is forwarded
 * to Honeycomb. Never throws and never blocks the caller.
 *
 * @param {object} params
 * @param {string} params.eventType   - One of the client_login_error event names
 * @param {string} params.errorCode   - Firebase error code (e.g. auth/wrong-password)
 * @param {string} params.errorMessage - err.message from the caught error
 * @param {string} params.email       - The email address used during the login attempt
 * @param {string} params.platform    - 'web' | 'ios' | 'android'
 * @param {string} params.appVersion  - Semver string from package.json
 */
export function logLoginError({
  eventType,
  errorCode,
  errorMessage,
  email,
  platform,
  appVersion,
}) {
  axios
    .post(`${apiHost}/auth/client-log`, {
      event_type: eventType,
      error_code: errorCode,
      error_message: errorMessage,
      email,
      platform,
      app_version: appVersion,
    })
    .catch(() => {});
}
